import * as React from 'react';
import clsx from 'clsx';
import { withTranslator } from '@gandi/translate';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Password extends React.Component {
  static defaultProps = {
    className: '',
    style: {}
  };
  state = {
    hidden: true
  };
  getInputType() {
    return this.state.hidden ? 'password' : 'text';
  }
  getButtonText() {
    const {
      translator
    } = this.props;
    return this.state.hidden ? translator.__('Show') : translator.__('Hide');
  }
  toggle = () => {
    this.setState(prev => ({
      hidden: !prev.hidden
    }));
  };
  render() {
    const {
      translator,
      error,
      className,
      style,
      isField,
      ...extraProps
    } = this.props;
    return /*#__PURE__*/_jsxs("span", {
      className: clsx('InputGroup', className),
      style: style,
      children: [/*#__PURE__*/_jsx("input", {
        type: this.getInputType(),
        className: "InputGroup-input InputGroup-input--block",
        ...extraProps
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "InputGroup-button",
        onClick: this.toggle,
        children: this.getButtonText()
      })]
    });
  }
}
export default withTranslator({
  propsNamespace: 'translator'
})(Password);